import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { GET_PRODUCT_PRICE_INFO } from "../../../data/definitions/product-definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { GetProductPriceInfoQuery, GetProductPriceInfoQueryVariables, ProductPriceInfo, ProductPriceInfoInput } from "../../../generated/generated-types";


@Injectable({
  providedIn: 'root'
})
export class ProductPriceInfoService extends BaseListService<ProductPriceInfo> {

  constructor(private dataService: DataService,
    private baseDataService: BaseDataService,
    private systemService: SystemService) {
    super();
  }

  getProductPriceInfo(args: ProductPriceInfoInput) {

    return this.baseDataService.query<GetProductPriceInfoQuery, GetProductPriceInfoQueryVariables>(
      GET_PRODUCT_PRICE_INFO, {
      input: args
    });
  }

  async getProductPriceInfoData(args: ProductPriceInfoInput): Promise<ProductPriceInfo[]> {
    let l = await lastValueFrom(this.getProductPriceInfo(args).single$);
    return l.getProductPriceInfo as ProductPriceInfo[];
  }

}
